import { useState } from "react";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { api, errMsg, imgSrc } from "@/lib/api";

export const ImageInput = ({ value, onChange }) => {
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      const { data } = await api.post("/upload", fd);
      onChange(data.url); toast.success("Gambar diunggah");
    } catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div className="space-y-3">
      <Tabs defaultValue="upload">
        <TabsList>
          <TabsTrigger value="upload" data-testid="image-tab-upload">Unggah dari perangkat</TabsTrigger>
          <TabsTrigger value="url" data-testid="image-tab-url">Tempel tautan</TabsTrigger>
        </TabsList>
        <TabsContent value="upload">
          <label className="flex flex-col items-center justify-center gap-2 border-2 border-dashed border-slate-300 p-8 cursor-pointer hover:border-[#C8102E] transition-colors">
            <Upload size={20} className="text-slate-500" />
            <span className="text-sm text-slate-600">{busy ? "Mengunggah..." : "Klik untuk pilih gambar (maks 5MB)"}</span>
            <input type="file" accept="image/*" className="hidden" onChange={upload} disabled={busy} data-testid="image-file-input" />
          </label>
        </TabsContent>
        <TabsContent value="url">
          <Input placeholder="https://contoh.com/gambar.jpg" value={value?.startsWith("/api/") ? "" : value || ""}
            onChange={(e) => onChange(e.target.value)} data-testid="image-url-input" />
        </TabsContent>
      </Tabs>
      {value && (
        <div className="relative w-full max-w-md aspect-video bg-slate-100" data-testid="image-preview">
          <img src={imgSrc(value)} alt="Pratinjau" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange("")} data-testid="image-remove-button"
            className="absolute top-2 right-2 bg-white/90 p-1 hover:bg-white"><X size={16} /></button>
        </div>
      )}
    </div>
  );
};
